import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

export const NewShow = () => {
  return (
    <section id="nuevo-espectaculo" data-testid="new-show-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1600px] px-6 sm:px-12 lg:px-24">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <Reveal>
              <p className="eyebrow flex items-center gap-3">
                <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />
                Nuevo espectáculo
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2
                data-testid="new-show-title"
                className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-cream text-balance"
              >
                «Machín en <span className="italic text-gold">Trío</span>»
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-5 text-base md:text-lg leading-relaxed text-sand">
                Tributo al inolvidable Antonio Machín: boleros y son bajo las luces de La Habana, con la voz y el sello de siempre de Cuarto Bolero.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="shrink-0">
            <button
              data-testid="new-show-cta-button"
              onClick={() => scrollToId("contratacion")}
              className="group inline-flex items-center gap-3 rounded-full bg-gold px-8 py-3.5 text-[13px] font-medium uppercase tracking-[0.18em] text-ink transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_10px_40px_rgba(212,175,55,0.35)]"
            >
              Contrata este espectáculo
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.1} y={36} className="mt-12">
          <figure data-testid="new-show-image" className="group relative overflow-hidden border border-gold/20">
            <img
              src="/posters/machin-en-trio-wide.webp"
              alt="«Machín en Trío», feat. Cuarto Bolero — tributo al inolvidable Antonio Machín"
              className="h-56 w-full object-cover object-[68%_center] sm:h-auto sm:object-center transition-transform duration-700 group-hover:scale-[1.02]"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/45 via-transparent to-transparent" />
          </figure>
        </Reveal>
      </div>
    </section>
  );
};